import { Fade, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useAppSelector } from "../../../store/hooks";
import { selectActiveRobotVersion } from "../../../store/ses/sesRobotSlice";
import { selectClusterServer } from "../../../store/serverSlice";
import useAccessRight from "../../../hooks/useAccessRight";
import useTranslate from "../../../hooks/useTranslate";
import { SES } from "../../../constants/accessRights";
import { ROBOT_SERVICE_DATA_LIST } from "../../../constants/robotConfigLists";
import { colorPrimary } from "../../../constants/colors";
import { ServiceDataType } from "../../../types/ses/sesRobotTypes";
import ServiceData from "../ServiceData/ServiceData";
import BlockWithInfo from "../../../ui/BlockWithInfo/BlockWithInfo";
import FormAddingServiceData from "../../Forms/FormAddingServiceData/FormAddingServiceData";
import { IServiceDataTabProps } from "./ServiceDataTab.props";
import styles from "./ServiceDataTab.module.scss";

const ServiceDataTab = ({ robotData, changeFlgHandler, selectServiceData, setSelectServiceData }: IServiceDataTabProps): JSX.Element => {
	const activeRobotVersion = useAppSelector(selectActiveRobotVersion); // store - версия активного робота
	const { smc: clusterServerSmc, see: clusterServerSee } = useAppSelector(selectClusterServer); // store - список моделей на сервере cluster

	const isAccess = useAccessRight(); // hook для проверки прав доступа
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Fade in={true} timeout={500}>
			<div className={styles.container}>
				<div className={styles.block}>
					{/* сервисные данные */}
					<FormControl fullWidth sx={{ '.MuiInputLabel-root[data-shrink="false"]': { top: -8 }, ".MuiSelect-select": { paddingBlock: 0 } }}>
						<InputLabel sx={{ fontSize: 13 }}>{translate("select_serviceData")}</InputLabel>
						<Select
							label={translate("select_serviceData")}
							value={selectServiceData}
							onChange={(e) => setSelectServiceData(e.target.value as ServiceDataType)}
							style={{ fontSize: 13, height: 33, color: colorPrimary }}
						>
							{ROBOT_SERVICE_DATA_LIST.map(({ serviceData, translation }) => (
								<MenuItem key={serviceData} value={serviceData} sx={{ fontSize: 13, color: colorPrimary }}>
									{translate(translation)}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</div>

				<div className={styles.serviceData}>
					{robotData.servicedata[selectServiceData] ? (
						<ServiceData
							data={robotData.servicedata[selectServiceData]}
							serviceDataName={selectServiceData}
							modelsList={robotData.servicedata[selectServiceData].type === "smc" ? clusterServerSmc.modelList : clusterServerSee.modelList}
							changeFlgHandler={changeFlgHandler}
						/>
					) : isAccess(SES.ROBOT_EDIT) && activeRobotVersion === "draft" ? (
						<FormAddingServiceData serviceDataName={selectServiceData} changeFlgHandler={changeFlgHandler} />
					) : (
						<BlockWithInfo title="title_empty" />
					)}
				</div>
			</div>
		</Fade>
	);
};

export default ServiceDataTab;
